import React, { Component } from 'react';
import DownloadConfigSelect from './DownloadConfigSelect'; 
import RequestConfigTable from './RequestConfigTable';

class DownloadConfig extends Component {

  render() {
    return (
      <div >
        <DownloadConfigSelect />
        <br />
        <RequestConfigTable />
      </div>
    );
  }
}

export default DownloadConfig;
